import Vue from "vue";
import Vuex from "vuex";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    dash: null,
    results: null,
    pagination: null,
    statusId: null,
    orderBy: null,
    orderByAsc: null,
    search: null,
    dateFrom: null,
    dateTo: null,
    page: 0,
    pageSize: 10,
    totalResults: null,
    customerDetails: null,
    listUpdated: false
  },
  mutations: {
    SET_DASH(state, payload) {
      state.dash = payload;
    },
    SET_RESULTS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
      state.page = payload.pagination.page;
      state.pageSize = payload.pagination.pageSize;
      state.totalResults = payload.pagination.totalResults;
    },
    SET_STATUS_ID(state, payload) {
      state.statusId = payload;
    },
    SET_ORDER_BY(state, payload) {
      if (payload) {
        state.orderBy = payload.orderBy;
        if (!payload.direction) state.orderByAsc = null;
        else if (payload.direction == "asc") state.orderByAsc = true;
        else state.orderByAsc = false;
      } else {
        state.orderBy = "firstName";
        state.orderByAsc = true;
      }
    },
    SET_SEARCH(state, payload) {
      state.search = payload;
    },
    SET_DATE_FROM(state, payload) {
      state.dateFrom = payload;
    },
    SET_DATE_TO(state, payload) {
      state.dateTo = payload;
    },
    SET_PAGE(state, payload) {
      state.page = payload;
    },
    SET_RESET_PAGE(state, payload) {
      state.page = 0;
      if (state.pagination.page) state.pagination.page = 0;
    },
    SET_RESET(state) {
      state.search = null;
      state.dash = null;
      state.results = null;
      state.pagination = null;
      state.statusId = null;
      state.orderBy = null;
      state.orderByAsc = null;
      state.search = null;
      state.dateFrom = null;
      state.dateTo = null;
      state.page = 0;
      state.pageSize = 10;
      state.totalResults = null;
      state.customerDetails = null;
      state.listUpdated = false;
    } /*
    SET_PAGE_SIZE(state, payload) {
      state.pageSize = payload;
      state.page = 1; //reset page on page size change
    },*/,
    SET_CUSTOMER_DETAILS(state, payload) {
      state.customerDetails = payload;
    },
    SET_LIST_UPDATED(state, payload) {
      state.listUpdated = payload;
    }
  },
  actions: {
    //PRE: you can send payload.params to override and set params
    //     at call time. Otherwise it uses the params previously set.
    async load({ commit }, payload) {
      try {
        const params = {
          orderBy: this.state.customers.orderBy || "firstName",
          orderAsc: this.state.customers.orderByAsc || true,
          page: this.state.customers.page + 1,
          pageSize: this.state.customers.pageSize,
          search: this.state.customers.search || ""
        };
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/customers`, {
          params
        });
        if (res.status != 200) {
          throw errors.handleHTTPError(res);
        }
        if (res.data.results.length > 0) {
          commit("SET_RESULTS", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadDash({ commit }, payload) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/customers/dash`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        if (res.data) {
          commit("SET_DASH", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadOne({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/customers/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_CUSTOMER_DETAILS", res.data);
      } catch (error) {
        throw error;
      }
    },
    reset({ commit }, id) {
      commit("SET_RESET");
    }
  },
  getters: {
    customers: state => {
      const customers = {
        dash: state.dash,
        results: state.results,
        pagination: state.pagination,
        statusId: state.statusId,
        orderBy: state.orderBy,
        search: state.search,
        dateFrom: state.dateFrom,
        dateTo: state.dateTo,
        page: state.page,
        pageSize: state.pageSize,
        totalResults: state.totalResults
      };
      return customers;
    },
    listUpdated: state => {
      return state.listUpdated;
    }
  }
};
